import React from "react";

import VerifyAccountScreen from "@/screens/Authentication/VerifyAccountScreen";

export default function Main(): React.JSX.Element {
  return <VerifyAccountScreen />;
}
